import { autorun } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import prefixr from 'react-prefixr';
import Link from 'components/Link';
// Import styles
import styles from './style.scss';

/**
 * InfiniteWall component
 *
 * It uses it's own store for state sync and various calculations.
 */

@inject('MediahubStore', 'ViewStore', 'WallStore')
@observer
class InfiniteWall extends Component {

  _updateScroll = _.debounce(() => {
    const { WallStore } = this.props;
    WallStore.updateScroll();
  }, 10);

  componentWillMount() {
    const { WallStore } = this.props;

    // Track scrolling using requestAnimationFrame
    this.untrackScroll = WallStore.updateScroll();

    // Track window scroll event
    // window.addEventListener('scroll', this._updateScroll.bind(this));
    // Track window resize event
    window.addEventListener('resize', this._updateDimensions.bind(this));
  }

  componentDidMount() {
    const { WallStore, ViewStore } = this.props;
    // Initialize Item Number
    WallStore.updateItemsCount(this.props.itemsCount);
    // Update Dimensions
    this._updateDimensions();

    autorun(() => {
      this._updateDimensions(ViewStore.parentTopOffset);
    });
  }

  componentWillReceiveProps(nextProps) {
    const { WallStore } = this.props;
    // Update Items Count
    WallStore.updateItemsCount(nextProps.itemsCount);
  }

  componentWillUnmount() {
    this.untrackScroll();

    // Remove Listeners
    // window.removeEventListener('scroll', this._updateScroll);
    window.removeEventListener('resize', this._updateDimensions);
  }

  _updateDimensions() {
    const { WallStore } = this.props;
    const wrapper       = this._wrapper;
    WallStore.updateDimensions(wrapper);
  }


  render() {
    const { itemsCount, items, itemsRenderer, WallStore, ViewStore } = this.props;

    const isEnglish = _.startsWith(ViewStore.currentPath, '/en');

    const linkTo   = isEnglish
      ? 'channel'
      : 'overview';
    const channel  = isEnglish
      ? 'english'
      : '';
    const linkText = isEnglish
      ? ViewStore.get('showAll')
      : ViewStore.get('backToOverview');

    return (
      <div ref={(ref) => this._wrapper = ref} >
        <div className={styles.container}
        style={{ height: WallStore.wrapperH }}
        >
          {/* {
            !!WallStore.itemsCount && _.map(WallStore.indexes, (index) => {
              const mc = itemsCount > index
                ? items[index]
                : {};
              return (
                <WallItem
                  key={`item_${index}`}
                  index={index}
                  mc={mc}
                  itemsRenderer={itemsRenderer} />
              );
            })
          } */}
          {
            !!WallStore.itemsCount && items.map( (item, index) => {
            const mc = itemsCount > index
            ? items[index]
            : {};
          return (
            <WallItem
              key={`item_${index}`}
              index={index}
              mc={mc}
              itemsRenderer={itemsRenderer} />
          );
        })
          }
          {
            !!WallStore.itemsCount &&
              <div className={styles.button_wrapper}>
                <Link to={linkTo} channel={channel} >
                  {
                    linkText
                  }
                </Link >
              </div>
            }
        </div >
      </div >
    );
  }
}

@inject('WallStore')
@observer
class WallItem extends Component {

  getItemStyle() {
    const { index, WallStore } = this.props;
    const item                 = WallStore.getPosition(index);

    return prefixr({
      transform: 'translate3d(' + item.posX + 'px, ' + item.posY + 'px, 0)',
      height:    WallStore.itemH,
      width:     WallStore.itemW,
    });
  }

  render() {
    const { itemsRenderer, mc, WallStore } = this.props;
    const { isMobile }                     = WallStore;
    return (
      <div
        className={styles.item}
        // style={this.getItemStyle()}
         >
        {
          React.createElement(itemsRenderer, { mc, isMobile })
        }
      </div >
    );
  }

}

export default InfiniteWall;



// WEBPACK FOOTER //
// ./src/components/InfiniteWall/index.js